export const MODAL_HEIGHT = 568;
export const MODAL_WIDTH = 968;

export const JIRA_NIN_LIST_MERGE_MODAL_ONBOARDING_TRIGGER_ID_WITH_COPY_LIST_SETTINGS =
	'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-with-copy-list-settings';
export const JIRA_NIN_LIST_MERGE_MODAL_ONBOARDING_TRIGGER_ID_WITHOUT_COPY_LIST_SETTINGS =
	'jira-nin-list-merge-modal-onboarding-explore-list-view-button-clicked-without-copy-list-settings';

export const TELL_ME_MORE_URL =
	'https://community.atlassian.com/forums/Jira-articles/We-re-merging-List-and-All-work-one-powerful-view-for-all-teams/ba-p/3090105';

export const COPY_LIST_SETTINGS_YES = 'yes';
export const COPY_LIST_SETTINGS_NO = 'no';
